/* eslint-disable react-hooks/exhaustive-deps */
import { getLocationData } from "@/services/formDynamicApis";
import { Select, Radio } from "@mantine/core";
import { isNil } from "lodash";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import styles from "../../styles/dynamic-form.module.scss";
import { getDescriptionStyleJSX } from "../nonPrimitiveType/formDynamicInput";

export default function FormDynamicInputSelect(props) {
  if (props.inputTemplate && props.inputTemplate.type === "select") {
    return <FormDynamicInputSelectHelper {...props} />;
  }
  return <></>;
}

function FormDynamicInputSelectHelper(props) {
  const { locale } = useRouter();
  const [dataToLoop, setDataToLoop] = useState([]);
  const [oldInvisible, setOldInvisible] = useState(false);
  const [allowType, setAllowType] = useState(null);
  const [loaded, setLoaded] = useState(false);

  const inputTemplate = { ...props.inputTemplate };
  const inputProps = { ...props.formInputProps };

  const descriptionJSX = getDescriptionStyleJSX(inputTemplate);
  const radioValuesJSX = () => {
    return dataToLoop.map((data) => <Radio key={data.value} value={data.value} label={data.label} />)
  }

  const setupDataToLoop = (inputTemplate, data = []) => {
    let dataToBeLooped = data.length > 0 ? data : inputTemplate.select.options;
    for (let i = 0; i < dataToBeLooped.length; i++) {
      if (isObject(dataToBeLooped[i].label)) {
        dataToBeLooped[i].label =
          dataToBeLooped[i]?.label[locale] ?? dataToBeLooped[i].value;
      }
    }

    const valueField = inputTemplate.select.valueField || "code";
    const labelField = inputTemplate.select.labelField || "name";
    dataToBeLooped = dataToBeLooped
      .filter((e) => !isNil(e[valueField]) && !isNil(e[labelField]))
      .map((e) => {
        const returnData = {};
        returnData["value"] = e[valueField];
        returnData["label"] = e[labelField];
        return returnData;
      });

    if (inputTemplate.select.masterdata === "nationality") {
      const vietnamOptionIndex = dataToBeLooped.findIndex(
        (e) => e.value === "001"
      );
      if (vietnamOptionIndex >= 0) {
        dataToBeLooped = [
          dataToBeLooped[vietnamOptionIndex],
          ...dataToBeLooped.slice(0, vietnamOptionIndex),
          ...dataToBeLooped.slice(vietnamOptionIndex + 1),
        ];
      }
    }
    if (inputTemplate.specialOptions) {
      if (
        Array.isArray(inputTemplate.specialOptions.add) &&
        inputTemplate.specialOptions.add.length > 0
      ) {
        dataToBeLooped = [
          ...dataToBeLooped,
          ...inputTemplate.specialOptions.add,
        ];
      }

      if (
        Array.isArray(inputTemplate.specialOptions.remove) &&
        inputTemplate.specialOptions.remove.length > 0
      ) {
        dataToBeLooped = dataToBeLooped.filter((e) => {
          return !inputTemplate.specialOptions.remove.find((singleOption) => {
            return (
              singleOption.label === e.label || singleOption.value === e.value
            );
          });
        });
      }
      if (
        Array.isArray(inputTemplate.specialOptions.prefixes) &&
        inputTemplate.specialOptions.prefixes.length > 0
      ) {
        dataToBeLooped = dataToBeLooped.sort((a, b) => {
          const aOptionFind = inputTemplate.specialOptions.prefixes.find(
            (singleOption) => {
              return (
                singleOption.label === a.label || singleOption.value === a.value
              );
            }
          );

          const bOptionFind = inputTemplate.specialOptions.prefixes.find(
            (singleOption) => {
              return (
                singleOption.label === b.label || singleOption.value === b.value
              );
            }
          );

          if (aOptionFind && !bOptionFind) {
            return -1;
          }
          if (bOptionFind && !aOptionFind) {
            return 1;
          }
          return 0;
        });
      }
      if (
        Array.isArray(inputTemplate.specialOptions.suffixes) &&
        inputTemplate.specialOptions.suffixes.length > 0
      ) {
        dataToBeLooped = dataToBeLooped.sort((a, b) => {
          const aOptionFind = inputTemplate.specialOptions.suffixes.find(
            (singleOption) => {
              return (
                singleOption.label === a.label || singleOption.value === a.value
              );
            }
          );
          const bOptionFind = inputTemplate.specialOptions.prefixes.find(
            (singleOption) => {
              return (
                singleOption.label === b.label || singleOption.value === b.value
              );
            }
          );
          if (aOptionFind && !bOptionFind) {
            return 1;
          }
          if (bOptionFind && !aOptionFind) {
            return -1;
          }
          return 0;
        });
      }
    }

    dataToBeLooped = dataToBeLooped.map((item) => ({
      value: String(item.value ?? ""),
      label:
        typeof item.label === "string"
          ? item.label
          : item.label?.[locale] ?? String(item.label ?? item.value ?? ""),
    }));
    return dataToBeLooped;
  };

  const isObject = (val) =>
    val !== null && typeof val === "object" && !Array.isArray(val);

  inputProps.onChange = (value) => {
    if (!value) {
      props.formInputProps.onChange(value);
      if (allowType) {
        setAllowType(null);
      }
      return;
    }

    if (props.handleDataInSelect) {
      props.handleDataInSelect(inputTemplate, value);
    }
    const allowTypeConfig =
      inputTemplate.select && inputTemplate.select.allowType
        ? { ...inputTemplate.select.allowType }
        : null;
    if (allowTypeConfig && value === allowTypeConfig.value) {
      if (!allowType) {
        setAllowType({ ...allowTypeConfig, textValue: "" });
        props.formInputProps.onChange(
          value + allowTypeConfig.delimiter || "\\"
        );
      } else {
        props.formInputProps.onChange(
          value + (allowType.delimiter || "\\") + allowType.textValue
        );
      }
    } else {
      setAllowType(null);
      props.formInputProps.onChange(value);
    }
  };

  useEffect(() => {
    if (
      !inputProps.dataRef &&
      inputTemplate.select &&
      inputTemplate.select.options &&
      Array.isArray(inputTemplate.select.options)
    ) {
      const dataToBeLooped = setupDataToLoop(inputTemplate);

      setDataToLoop(dataToBeLooped);
    }
  }, [inputTemplate.select]);

  useEffect(() => {
    if (
      inputTemplate.select &&
      inputTemplate.select.masterdata &&
      props.hostNameUrl &&
      inputTemplate._dataRef
    ) {
      if (!inputProps.dataRef || inputProps.dataRef.length === 0) {
        setDataToLoop([]);
        inputProps.onChange("");
        if (!!loaded) {
          setLoaded(true);
        }
        return;
      } else {
        getLocationData(
          inputTemplate.select.masterdata,
          inputProps.dataRef,
          props.hostNameUrl
        ).then((res) => {
          if (!res.isError) {
            const dataToBeLooped = setupDataToLoop({ ...inputTemplate }, [
              ...res.data,
            ]);
            if (!loaded) {
              inputProps.onChange(props.initialValue);
              setLoaded(true);
            } else {
              inputProps.onChange("");
            }
            setDataToLoop(dataToBeLooped);
          }
        });
      }
    }
  }, [inputProps.dataRef]);

  useEffect(() => {
    if (props.formInputProps.value) {
      if (props.formInputProps.value === "") {
        return;
      }
      let valueToCompare =
        props.inputTemplate.defaultValue ?? props.formInputProps.value;
      const delimiter = allowType ? allowType.delimiter || "\\" : "\\";
      if (props.formInputProps.value.includes(delimiter)) {
        const splitValue = props.formInputProps.value.split(delimiter);
        if (splitValue.length === 2) {
          valueToCompare = splitValue[0];
          if (!allowType || allowType.textValue !== splitValue) {
            setAllowType({
              ...inputTemplate.select.allowType,
              textValue: splitValue[1],
            });
          }
        }
      }
    }
  }, [dataToLoop, props.formInputProps.value]);

  useEffect(() => {
    if (inputTemplate.invisible) {
      setOldInvisible(true);
      inputProps.onChange(undefined);
      setAllowType(null);
    } else if (oldInvisible) {
      setOldInvisible(false);
      inputProps.onChange(props.initialValue);
    }
  }, [inputTemplate.invisible]);

  useEffect(() => {
    if (
      props.formInputProps.value === undefined &&
      !inputTemplate.invisible &&
      !props.initialValue
    ) {
      props.formInputProps.onChange("");
    }
  }, [props.formInputProps.value]);

  useEffect(() => {
    console.log("select dataToLoop", dataToLoop)
  }, [dataToLoop])

  return (
    !inputTemplate.isRadio ?
      <Select
        {...inputProps}
        className={`${styles.formDynamicTextDateSelectInput} formDynamicTextDateSelectInput`}
        description={descriptionJSX}
        label={
          inputTemplate.labelNoWrap ? (
            <span style={{ textWrap: "nowrap" }}>{inputTemplate.label}</span>
          ) : (
            inputTemplate.label
          )
        }
        placeholder={
          inputTemplate.placeholder
            ? inputTemplate.placeholder
            : inputTemplate.label
        }
        disabled={props.disabledInput || inputProps.disabled}
        withAsterisk={props.requiredInput}
        clearable
        searchable
        nothingFound="Không có lựa chọn đó trong danh sách"
        data={dataToLoop}
        maxDropdownHeight={280}
      />
      :
      <Radio.Group
        name="radio"
        className={`${styles.formDynamicRadioInput} formDynamicRadioInput`}
        label={
          inputTemplate.labelNoWrap ? (
            <span className={`${styles.formDynamicRadioGroupLabel} formDynamicRadioGroupLabel`} style={{ textWrap: "nowrap" }}>
              {inputProps.label || inputTemplate.label}
            </span>
          ) : (
            <span className={`${styles.formDynamicRadioGroupLabel} formDynamicRadioGroupLabel`}>
              {inputProps.label || inputTemplate.label}
            </span>
          )
        }
        description={descriptionJSX}
        withAsterisk={props.requiredInput}
        error={inputProps.error}
        {...inputProps}
      >
        {radioValuesJSX()}
      </Radio.Group>
  )
    ;
}
